import { Routes, Route } from 'react-router-dom';
import loadable from '@loadable/component';
import AuthProvider from '../../providers/auth.provider';
import { config } from '../../config';
import CheckCMSNewVersionLayer from '../../components/layout/CheckCMSNewVersionLayer';

const liffId = config.liff_id.policyLoan;

const PolicyLoan = loadable(() => import('./PolicyLoan'), { fallback: null });

const PolicyLoanPending = loadable(() => import('./PolicyLoanPending'), { fallback: null });

const PolicyLoanAbout = loadable(() => import('./PolicyLoanAbout'), { fallback: null });

const PolicyLoanConsent = loadable(() => import('./PolicyLoanConsent'), { fallback: null });

const PolicyLoanForm = loadable(() => import('./PolicyLoanForm'), { fallback: null });

const PolicyLoanSummary = loadable(() => import('./PolicyLoanSummary'), { fallback: null });

const PolicyLoanOtp = loadable(() => import('./PolicyLoanOtp'), { fallback: null });

const PolicyLoanCancelOtp = loadable(() => import('./PolicyLoanCancelOtp'), { fallback: null });

const PolicyLoanCancelComplete = loadable(() => import('./PolicyLoanCancelComplete'), { fallback: null });

const PolicyLoanComplete = loadable(() => import('./PolicyLoanComplete'), { fallback: null });

const NotFound = loadable(() => import('../NotFound'), { fallback: null });

export default function PolicyLoanRoute() {
	return (
		<Routes>
			<Route path="/" element={
				<AuthProvider liffId={liffId}>
					<CheckCMSNewVersionLayer>
						<PolicyLoan />
					</CheckCMSNewVersionLayer>
				</AuthProvider>
			} />
			<Route path="policy-pending" element={<PolicyLoanPending />} />
			<Route path="tooltip-information" element={<PolicyLoanAbout />} />
			<Route path="consent-TC" element={<PolicyLoanConsent />} />
			<Route path="fillin-form" element={<PolicyLoanForm />} />
			<Route path="summary" element={<PolicyLoanSummary />} />
			<Route path="confirmation-otp" element={<PolicyLoanOtp />} />
			<Route path="cancel-otp" element={<PolicyLoanCancelOtp />} />
			<Route path="cancel-complete" element={<PolicyLoanCancelComplete />} />
			<Route path="complete" element={<PolicyLoanComplete />} />
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
}
